/**
 * app/(marketing)/legal/delete-account.tsx - getabeam.com Account Deletion page (web, public).
 * This is the public deletion URL referenced from the Google Play Data Safety form.
 * Content lives in src/marketing/legal.ts; rendering in src/marketing/legalPage.tsx.
 */
import { LegalPage } from '../../../src/marketing/legalPage';
import { legalDocBySlug } from '../../../src/marketing/legal';

export default function DeleteAccountScreen() {
  return <LegalPage doc={legalDocBySlug('delete-account')} />;
}
